// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3A6lV","item":"PaymentsMobile_item__3gkrE","label":"PaymentsMobile_label__ylUe1","amount":"PaymentsMobile_amount__2xBTv"};